//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'AppFooterNavItem',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters('user', ['userStatus']),

    show() {
      return this.item.if ? this.userStatus(this.item.if) : true
    },

    isExternal() {
      return this.item.external || false
    },

    dataNode() {
      return this.item['data-node'] || false
    },

    itemClasses() {
      return this.item.class || null
    }
  }
}
